import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import EmptyStructureSet from '../ContouringStep/EmptyStructureSet/EmptyStructureSet';
import ImageHeader from '../ContouringStep/StructureSet/ImageHeader/ImageHeader';
import StepHeader from '../StepHeader';
import ReviewStructureSet from './ReviewStructureSet/ReviewStructureSet';

export default function ReviewContent() {
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    return (
        selectedPatientId && (
            <Box height="100%" position="relative" display="grid">
                <Box
                    position="relative"
                    display="grid"
                    gridTemplateRows="auto 1fr"
                >
                    <Box>
                        <StepHeader titleId="workflow.review" />
                        {!currentStructureSet && <EmptyStructureSet />}
                        <Divider sx={{ my: 1 }} />
                        <ImageHeader />
                    </Box>
                    {currentStructureSet && (
                        <Box
                            height="100%"
                            display="grid"
                            gridTemplateRows="auto 1fr"
                        >
                            <Divider sx={{ mb: 1, mt: 1.5 }} />
                            <ReviewStructureSet
                                structureSet={currentStructureSet}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        )
    );
}
